export default __webpack_public_path__ + "static/media/no-images-proponent.21af7dca.svg";